var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { pl, pr } from '@lendi-ui/spacing';
import { FULLSTORY_EXCLUDE_CLASS } from '../../fullstory';
export var MessageListWrapper = styled.div.attrs({
    className: FULLSTORY_EXCLUDE_CLASS,
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow-x: hidden;\n  overflow-y: auto;\n  ", ";\n  ", ";\n\n  ", ";\n"], ["\n  overflow-x: hidden;\n  overflow-y: auto;\n  ", ";\n  ", ";\n\n  ", ";\n"])), pr('sm'), pl('xxs'), function (props) {
    return !props.isExperiment
        ? "\n          height: 100%;\n        "
        : "\n          & > div:first-child {\n            margin-top: 30px;\n          }\n        ";
});
var templateObject_1;
//# sourceMappingURL=style.js.map